import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { impuestoService, Impuesto, ImpuestoCreate, ImpuestoUpdate } from '../../services/impuestoService';
import ImpuestoForm from '../../components/Impuestos/ImpuestoForm';

const ImpuestosList = () => {
  const [showForm, setShowForm] = useState(false);
  const [impuestoEditando, setImpuestoEditando] = useState<Impuesto | null>(null);
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery(
    'impuestos',
    () => impuestoService.getAll()
  );

  const deleteMutation = useMutation(
    (id: number) => impuestoService.delete(id),
    {
      onSuccess: () => {
        toast.success('Impuesto eliminado correctamente');
        queryClient.invalidateQueries(['impuestos']);
      },
      onError: (error: any) => {
        toast.error(error.response?.data?.error?.message || 'Error al eliminar impuesto');
      }
    }
  );

  const handleEdit = (impuesto: Impuesto) => {
    setImpuestoEditando(impuesto);
    setShowForm(true);
  };

  const handleCreate = () => {
    setImpuestoEditando(null);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setImpuestoEditando(null);
  };

  const handleDelete = (id: number) => {
    if (window.confirm('¿Estás seguro de eliminar este impuesto?')) {
      deleteMutation.mutate(id);
    }
  };

  if (isLoading) return <div>Cargando impuestos...</div>;
  if (error) return <div>Error al cargar impuestos</div>;

  const impuestos = data?.data.impuestos || [];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Impuestos</h1>
        <button
          onClick={handleCreate}
          className="px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700"
        >
          + Nuevo Impuesto
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Porcentaje
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Tipo
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Aplica a
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Estado
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {impuestos.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-6 py-4 text-center text-gray-500">
                  No hay impuestos registrados
                </td>
              </tr>
            ) : (
              impuestos.map((impuesto) => (
                <tr key={impuesto.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {impuesto.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {impuesto.porcentaje}%
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {impuesto.tipo.toUpperCase()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {impuesto.aplicaA}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        impuesto.isActive
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                      }`}
                    >
                      {impuesto.isActive ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button
                      onClick={() => handleEdit(impuesto)}
                      className="text-primary-600 hover:text-primary-900 mr-4"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => handleDelete(impuesto.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showForm && (
        <ImpuestoForm
          impuesto={impuestoEditando}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default ImpuestosList;

